var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ShieldChevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M18.9765 15.3828C16.9687 19.1517 13.1977 20.6081 12.2312 20.9285C12.082 20.9798 11.9199 20.9798 11.7707 20.9285C10.8043 20.6081 7.0332 19.1517 5.02539 15.3828L5.02568 15.3827L12.001 10.5L18.9762 15.3827L18.9765 15.3828Z",
    fill: "url(#paint0_linear_514_2331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.75 10V4.5C3.75 4.30109 3.82902 4.11032 3.96967 3.96967C4.11032 3.82902 4.30109 3.75 4.5 3.75H19.5C19.6989 3.75 19.8897 3.82902 20.0303 3.96967C20.171 4.11032 20.25 4.30109 20.25 4.5V10C20.25 17.8764 13.5651 20.486 12.2303 20.9285C12.0811 20.9798 11.9189 20.9798 11.7697 20.9285C10.4349 20.486 3.75 17.8764 3.75 10Z",
    stroke: "url(#paint1_linear_514_2331)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.9759 15.3827L12.0007 10.5L5.02539 15.3827",
    stroke: "url(#paint2_linear_514_2331)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_514_2331",
    x1: 18.9765,
    y1: 14.9485,
    x2: 5.02539,
    y2: 14.9485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_514_2331",
    x1: 20.25,
    y1: 11.0672,
    x2: 3.75,
    y2: 11.0672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_514_2331",
    x1: 18.9759,
    y1: 12.5751,
    x2: 5.02539,
    y2: 12.5751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldChevron);
export default __webpack_public_path__ + "static/media/ShieldChevron.d0021912d3509730c2211929d91def86.svg";
export { ForwardRef as ReactComponent };